import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';
import {IAct} from '@gongxigames/framework/slotV2/fsm/stateMachineTypes';

export class State {
    static ID = '__NONE__';

    static createState(): State {
        if (!this.ID && this.ID === '__NONE__') {
            throw new Error('State Name is not set...');
        }

        return new this(this.ID);
    }

    public act?: IAct;

    constructor(
        readonly name: string
    ) {}

    public activate(onExit: () => void): void {
        this.logActivation();

        this.setAct();
        this.validateAct();
        this.act?.execute(onExit);
    }

    public deactivate(): void {
        this.act?.dispose();
        this.act = undefined;
    }

    protected logActivation(): void {
        consoleLogger.log(`Run state ===> ${this.name}`);
    }

    // TODO: refactor getAct() => ActConstructor... maybe as abstract fn...
    /**
     * fill state by actions here
     */
    public setAct(): void {}

    /**
     * guard logic should be here
     */
    public canExecute(): boolean {
        return true;
    }

    // TODO: remove check in the StateMachine
    private validateAct() {
        /* develblock:start */
        if (!this.act) {
            consoleLogger.error(`State "${this.name}" doesn't contain act`);
        }
        /* develblock:end */
    }
}